import { isNuloOuUndefined } from '@utils';

export class NumberUtils {
	static getIgnorandoCasasDecimais(
		valor: string | number,
		numeroCasasDecimais = 1
	) {
		if (isNuloOuUndefined(valor)) {
			throw Error('Valor não pode ser null');
		}
		return Number(Number(valor).toFixed(numeroCasasDecimais));
	}

	static ehConversivelEmNumber(valor: string): boolean {
		if (!isNaN(Date.parse(valor))) {
			return false;
		}
		return !isNaN(Number(valor));
	}
}
